class TextMedia extends HTMLElement {
	constructor() {
		super();
		const cta = this.querySelector('.cta-js');
		const onClickTab = (e) => {
			e.preventDefault();
			const target = e.target;
			seamless.elementScrollIntoView(
				document.querySelector(`#${target.href.split('#')[1]}`),
				{
					behavior: 'smooth',
				}
			);
		};

		cta.addEventListener('click', onClickTab, false);
	}
}
class PerksCards extends HTMLElement {
	constructor() {
		super();
		const cards = this.querySelector('.cards');

		this.querySelectorAll('.item').forEach((item) => {
			let observer = new IntersectionObserver(
				(el) => {
					if (
						el[0].isIntersecting === true &&
						!el[0].target.classList.contains('is-in-view')
					) {
						el[0].target.classList.add('is-in-view');
					} else {
						el[0].target.classList.remove('is-in-view');
					}
				},
				{
					root: null,
					threshold: [0.7], // 0 = page start; 1 = page bottom, items only revealed when in full view
				}
			);

			observer.observe(item);
		});

		const onMouseover = (e) => {
			cards.classList.add('is-focus');
			const target = e.target.closest('.item');
			if (!target || target.classList.contains('is-active')) {
				return;
			}
			target.classList.add('is-active');
		};

		const onMouseout = (e) => {
			cards.classList.remove('is-focus');
			const target = e.target.closest('.item');
			if (!target) {
				return;
			}

			target.classList.remove('is-active');
		};

		cards.addEventListener('mouseover', onMouseover);
		cards.addEventListener('mouseout', onMouseout);
	}
}

customElements.define('perks-cards', PerksCards);

customElements.define('text-media', TextMedia);
class ShopTabs extends HTMLElement {
	constructor() {
		super();

		const tabsContainer = this.querySelector('.tabs-container');
		const productItem = Array.from(
			document.querySelectorAll('.product-content .product-item')
		);

		console.log(productItem);

		const tabsProductList = this.querySelectorAll('.tabs-product-list');

		const onClickTab = (e) => {
			const target = e.target.closest('.tab-button');
			if (!target || target.classList.contains('is-active')) {
				return;
			}

			tabsProductList.forEach((item) => {
				let target = item.querySelector('.tabs-select-trigger');

				if (target.classList.contains('h-custom')) {
					target.classList.remove('h-custom');
				}
			});

			const targetId = target.dataset.productId;
			const tabs = Array.from(tabsContainer.querySelectorAll('.tab-button'));

			tabs.forEach((item) => {
				item.classList.toggle(
					'is-active',
					item.getAttribute('data-product-id') === targetId
				);
			});

			productItem.forEach((item) => {
				item.classList.toggle(
					'is-active',
					item.getAttribute('data-product-id') === targetId
				);
			});
		};

		tabsContainer.addEventListener('click', onClickTab, false);
	}
}

customElements.define('shop-tabs', ShopTabs);

class ProductTabsItem extends HTMLElement {
	constructor() {
		super();

		const tabsContainer = this.closest('.product-list').querySelector('.tabs-container');
		const productItem = this.querySelectorAll('.product-content .product-item');

		const onClickTab = (e) => {
			const target = e.target.closest('.tab-button');
			if (!target || target.classList.contains('is-active')) {
				return;
			}

			const targetId = target.dataset.productId;
			const tabs = tabsContainer.querySelectorAll('.tab-button');

			tabs.forEach((item) => {
				item.classList.remove('is-active');
			});

			productItem.forEach((item) => {
				item.classList.remove('is-active');
			});

			target.classList.add('is-active');
			
			this.closest('.product-list').querySelectorAll('.product-item').forEach(el => {
				const productId = el.getAttribute('data-product-id');
				el.classList.toggle('is-active', productId == targetId);
			})
		};

		tabsContainer.addEventListener('click', onClickTab, false);
	}
}

customElements.define('product-tabs-item', ProductTabsItem);
